/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { Grid } from '@mui/material';
import { Subtitulo, CustomModal, EnhancedTable, Line } from '@monorepo-web/components-library';
import {
  fetchModalPosCon,
  sendAnalyticsData,
  useFetchAPIs,
  useAppDispatch,
  useAppSelector,
  getColumnsDadosAgrupados,
  formatRowsDadosAgrupados,
  formatRowsHistorico,
  getColumnsHistorico,
} from '@monorepo-web/logic-extrato';

import LoadingModal from '../LoadingModal';
import HeaderWrapper from '../../MainLayout/HeaderWrapper';
import { TabelaPosicaoConsolidada } from '@monorepo-web/templates';

interface Props {
  dispatchPDF?: boolean;
  sendData?: any;
}

export default function PosicaoConsolidada({ dispatchPDF, sendData }: Props) {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const [
    obj_datas,
    dados_ativos_agrupados,
    datas_dados_ativos_agrupados,
    isLoaded,
    loading,
    dadosModal,
    loadingModal,
    loadedCarteiraList,
    isLoadingMinimized,
    params,
    preferenceCustomizacao,
  ] = useAppSelector((state) => [
    state.posCon.obj_datas,
    state.posCon.dados_ativos_agrupados,
    state.posCon.datas_dados_ativos_agrupados,
    state.posCon.isLoaded,
    state.posCon.loading,
    state.posCon.dadosModal,
    state.posCon.loadingModal,
    state.preference.loadedCarteiraList,
    state.loadMinimized.isLoadingMinimized,
    state.preference.params,
    state.preference.preferenceStyle.customizacao,
  ]);

  const [openModal, setOpenModal] = useState(false);
  const [ativoModal, setAtivoModal] = useState(false);
  const [nomeAtivoModal, setNomeAtivoModal] = useState('');

  const onRowClickHandle = async (data: any) => {
    if (!openModal && ativoModal !== data.ativo) await dispatch(fetchModalPosCon(data));
    if (!openModal) setAtivoModal(data.ativo);
    setOpenModal(!openModal);
  };

  useEffect(() => {
    if (!dispatchPDF)
      document.title = `${(window as any).env.REACT_APP_TABNAME} - Posição Consolidada`;
  }, []);

  useEffect(() => {
    if (isLoaded && !dispatchPDF) dispatch(sendAnalyticsData(location.href));
  }, [params, isLoaded]);

  useFetchAPIs(isLoaded, loading, dispatchPDF);

  const columnsDadosAgrupados = getColumnsDadosAgrupados(
    datas_dados_ativos_agrupados,
    preferenceCustomizacao,
  );
  const rowsDadosAgrupados = isLoaded
    ? formatRowsDadosAgrupados(
        theme,
        dispatchPDF,
        onRowClickHandle,
        setNomeAtivoModal,
        dados_ativos_agrupados,
      )
    : null;

  const rowsHistorico = formatRowsHistorico(dadosModal, loadingModal);
  const columnsHistorico = getColumnsHistorico();

  useEffect(() => {
    if (dispatchPDF) {
      const data = {
        rowsDados: rowsDadosAgrupados,
        columnsDados: columnsDadosAgrupados,
        datas_dados_ativos_agrupados
      };
      sendData('PosCon', data);
    }
  }, []);

  if (dispatchPDF) {
    return <></>;
  }

  return (
    <>
      <Grid>
        <HeaderWrapper
          dataFim
          title="Posição Consolidada"
          obj_datas={obj_datas}
          data_fim_apenas
          subtitle_date
        />
        <Line />
      </Grid>
      <Grid container sx={{ marginTop: 1 }}>
        <Grid item xs={12}>
          <TabelaPosicaoConsolidada
            rows={rowsDadosAgrupados}
            datas={datas_dados_ativos_agrupados}
            titulo=''
            percentHeaderText={preferenceCustomizacao?.PosCon_headerPercent}
          />
        </Grid>
      </Grid>
      <CustomModal open={openModal} onCloseHandle={onRowClickHandle}>
        <Subtitulo mb="8px">Histórico do Ativo - {nomeAtivoModal}</Subtitulo>
        <EnhancedTable rows={rowsHistorico} columns={columnsHistorico} height={400} />
      </CustomModal>
      <LoadingModal loading={loadingModal} showMinimizar={false} />
    </>
  );
}
